import BlogPageLayout from "./BlogPageLayout"



const Home = () => {

    return (
        <BlogPageLayout
            articulo='false'
        >
            {/* Hero */}
            <section className="home-hero-modern">
                <div className="home-hero-modern__content">
                    <h1>Salud Financiera: Tu guía para invertir y ahorrar</h1>
                    <p>Aprende a tomar el control de tus finanzas y construir un futuro seguro</p>
                    <a href="/libro" className="btn-primary">Ver capitulos</a>
                </div>
            </section>

            {/* Artículos destacados */}
            <section className="home-featured-articles container">
                <h2>Artículos destacados</h2>
                <div className="row">
                    {[1, 2, 3].map((i) => (
                        <div className="col-md-4" key={i}>
                            <div className="article-card">
                                <img src={`/img/post${i}.jpg`} alt={`Artículo ${i}`} />
                                <h5>Título del artículo {i}</h5>
                                <p>Resumen breve del artículo para captar la atención del lector...</p>
                                <a href={`/blog/post-${i}`} className="btn-link">Leer más</a>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Autor */}
            <section className="home-author container">
                <h2>Sobre el autor</h2>
                <div className="author-card">
                    <img src="/img/post1.jpg" alt="Autor" />
                    <div className="author-info">
                        <h5>Nombre del autor</h5>
                        <p>Breve descripción sobre la trayectoria del autor y su experiencia en finanzas personales.</p>
                        <a href="/autor" className="btn-link">Ver más</a>
                    </div>
                </div>
            </section>

        </BlogPageLayout>
    )

}

export default Home